import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../config/axios.config'
import { GET_TRANSACTION_ENDPOINT } from '../../Constants'

export const getTransactionByRecordNo = createAsyncThunk('transactions/:recordNo', async (recordNo: any): Promise<any> => {
  const responseData = await api.get(`/${GET_TRANSACTION_ENDPOINT}/${recordNo}`)
  return responseData.data
})
